[
  {
    "code": "be",
    "currencyCode": "EUR",
    "domain": "amazon.com.be",
    "id": "AMEN7PMS3EDWL",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "Belgium",
    "region": "eu",
    "sellerCentralDomain": "sellercentral.amazon.com.be",
    "vendorCentralDomain": "vendorcentral.amazon.com.be",
    "vendorId": "A3Q3FYJVX702M2"
  },
  {
    "advertisingApiDomain": "advertising-api-eu.amazon.com",
    "code": "de",
    "currencyCode": "EUR",
    "domain": "amazon.de",
    "id": "A1PA6795UKMFR9",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "Germany",
    "region": "eu",
    "sellerCentralDomain": "sellercentral-europe.amazon.com",
    "vendorCentralDomain": "vendorcentral.amazon.de",
    "vendorId": "A3JWKAKR8XB7XF"
  },
  {
    "code": "de-non-amazon",
    "currencyCode": "EUR",
    "id": "A38D8NSA03LJTC",
    "name": "Germany - Non-Amazon",
    "region": "eu"
  },
  {
    "advertisingApiDomain": "advertising-api-eu.amazon.com",
    "code": "es",
    "currencyCode": "EUR",
    "domain": "amazon.es",
    "id": "A1RKKUPIHCS9HS",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "Spain",
    "region": "eu",
    "sellerCentralDomain": "sellercentral-europe.amazon.com",
    "vendorCentralDomain": "vendorcentral.amazon.es",
    "vendorId": "A1AT7YVPFBWXBL"
  },
  {
    "code": "es-non-amazon",
    "currencyCode": "EUR",
    "id": "AFQLKURYRPEL8",
    "name": "Spain - Non-Amazon",
    "region": "eu"
  },
  {
    "advertisingApiDomain": "advertising-api-eu.amazon.com",
    "code": "fr",
    "currencyCode": "EUR",
    "domain": "amazon.fr",
    "id": "A13V1IB3VIYZZH",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "France",
    "region": "eu",
    "sellerCentralDomain": "sellercentral-europe.amazon.com",
    "vendorCentralDomain": "vendorcentral.amazon.fr",
    "vendorId": "A1X6FK5RDHNB96"
  },
  {
    "code": "fr-non-amazon",
    "currencyCode": "EUR",
    "id": "A1ZFFQZ3HTUKT9",
    "name": "France - Non-Amazon",
    "region": "eu"
  },
  {
    "advertisingApiDomain": "advertising-api-eu.amazon.com",
    "code": "it",
    "currencyCode": "EUR",
    "domain": "amazon.it",
    "id": "APJ6JRA9NG5V4",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "Italy",
    "region": "eu",
    "sellerCentralDomain": "sellercentral-europe.amazon.com",
    "vendorCentralDomain": "vendorcentral.amazon.it",
    "vendorId": "A11IL2PNWYJU7H"
  },
  {
    "code": "it-non-amazon",
    "currencyCode": "EUR",
    "id": "A62U237T8HV6N",
    "name": "Italy - Non-Amazon",
    "region": "eu"
  },
  {
    "advertisingApiDomain": "advertising-api-eu.amazon.com",
    "code": "uk",
    "currencyCode": "GBP",
    "domain": "amazon.co.uk",
    "id": "A1F83G8C2ARO7P",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "United Kingdom",
    "region": "eu",
    "sellerCentralDomain": "sellercentral-europe.amazon.com",
    "vendorCentralDomain": "vendorcentral.amazon.co.uk",
    "vendorId": "A3P5ROKL5A1OLE"
  },
  {
    "code": "uk-non-amazon",
    "currencyCode": "GBP",
    "id": "AZMDEXL2RVFNN",
    "name": "United Kingdom - Non-Amazon",
    "region": "eu"
  },
  {
    "code": "tr",
    "currencyCode": "TRY",
    "domain": "amazon.com.tr",
    "id": "A33AVAJ2PDY3EV",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "Turkey",
    "region": "eu",
    "sellerCentralDomain": "sellercentral.amazon.com.tr",
    "vendorCentralDomain": "vendorcentral.amazon.com.tr",
    "vendorId": "A1UNQM1SR2CHM"
  },
  {
    "code": "eg",
    "currencyCode": "EGP",
    "domain": "amazon.eg",
    "id": "ARBP9OOSHTCHU",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "Egypt",
    "region": "eu",
    "sellerCentralDomain": "sellercentral.amazon.eg",
    "vendorCentralDomain": "vendorcentral.amazon.me",
    "vendorId": "A1ZVRGNO5AYLOV"
  },
  {
    "code": "sa",
    "currencyCode": "SAR",
    "domain": "amazon.sa",
    "id": "A17E79C6D8DWNP",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "Saudi Arabia",
    "region": "eu",
    "sellerCentralDomain": "sellercentral.amazon.sa",
    "vendorCentralDomain": "vendorcentral.amazon.me",
    "vendorId": "A2XPWB6MYN7ZDK"
  },
  {
    "code": "nl",
    "currencyCode": "EUR",
    "domain": "amazon.nl",
    "id": "A1805IZSGTT6HS",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "Netherlands",
    "region": "eu",
    "sellerCentralDomain": "sellercentral.amazon.nl",
    "vendorCentralDomain": "vendorcentral.amazon.nl",
    "vendorId": "A17D2BRD4YMT0X"
  },
  {
    "code": "se",
    "currencyCode": "SEK",
    "domain": "amazon.se",
    "id": "A2NODRKZP88ZB9",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "Sweden",
    "region": "eu",
    "sellerCentralDomain": "sellercentral.amazon.se",
    "vendorCentralDomain": "vendorcentral.amazon.se",
    "vendorId": "ANU9KP01APNAG"
  },
  {
    "code": "pl",
    "currencyCode": "PLN",
    "domain": "amazon.pl",
    "id": "A1C3SOZRARQ6R3",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "Poland",
    "region": "eu",
    "sellerCentralDomain": "sellercentral.amazon.pl",
    "vendorCentralDomain": "vendorcentral.amazon.pl",
    "vendorId": "A2R2221NX79QZP"
  },
  {
    "advertisingApiDomain": "advertising-api.amazon.com",
    "code": "ca",
    "currencyCode": "CAD",
    "domain": "amazon.ca",
    "id": "A2EUQ1WTGCTBG2",
    "imagesDomain": "images-na.ssl-images-amazon.com",
    "name": "Canada",
    "region": "na",
    "sellerCentralDomain": "sellercentral.amazon.ca",
    "vendorCentralDomain": "vendorcentral.amazon.ca",
    "vendorId": "A3DWYIK6Y9EEQB"
  },
  {
    "code": "ca-non-amazon",
    "currencyCode": "CAD",
    "id": "A1MQXOICRS2Z7M",
    "name": "Canada - Non-Amazon",
    "region": "na"
  },
  {
    "code": "mx",
    "currencyCode": "MXN",
    "domain": "amazon.com.mx",
    "id": "A1AM78C64UM0Y8",
    "imagesDomain": "images-na.ssl-images-amazon.com",
    "name": "Mexico",
    "region": "na",
    "sellerCentralDomain": "sellercentral.amazon.com.mx",
    "vendorCentralDomain": "vendorcentral.amazon.com.mx",
    "vendorId": "AVDBXBAVVSXLQ"
  },
  {
    "code": "mx-non-amazon",
    "currencyCode": "MXN",
    "id": "A3H6HPSLHAK3XG",
    "name": "Mexico - Non-Amazon",
    "region": "na"
  },
  {
    "advertisingApiDomain": "advertising-api.amazon.com",
    "code": "us",
    "currencyCode": "USD",
    "domain": "amazon.com",
    "id": "ATVPDKIKX0DER",
    "imagesDomain": "images-na.ssl-images-amazon.com",
    "name": "United States",
    "region": "na",
    "sellerCentralDomain": "sellercentral.amazon.com",
    "vendorCentralDomain": "vendorcentral.amazon.com",
    "vendorId": "ATVPDKIKX0DER"
  },
  {
    "code": "us-non-amazon",
    "currencyCode": "USD",
    "id": "A2ZV50J4W1RKNI",
    "name": "United States - Non-Amazon",
    "region": "na"
  },
  {
    "code": "us-invoicing-shadow",
    "currencyCode": "USD",
    "id": "AHRY1CZE9ZY4H",
    "name": "United States - Invoicing Shadow Marketplace",
    "region": "na"
  },
  {
    "code": "us-amazon-pay",
    "currencyCode": "USD",
    "id": "AGWSWK15IEJJ7",
    "name": "United States - Amazon Pay",
    "region": "na"
  },
  {
    "code": "us-amazon-pay-sandbox",
    "currencyCode": "USD",
    "id": "A3BXB0YN3XH17H",
    "name": "United States - Amazon Pay Sandbox",
    "region": "na"
  },
  {
    "code": "br",
    "currencyCode": "BRL",
    "domain": "amazon.com.br",
    "id": "A2Q3Y263D00KWC",
    "imagesDomain": "images-na.ssl-images-amazon.com",
    "name": "Brazil",
    "region": "na",
    "sellerCentralDomain": "sellercentral.amazon.com.br",
    "vendorCentralDomain": "vendorcentral.amazon.com.br",
    "vendorId": "A1ZZFT5FULY4LN"
  },
  {
    "advertisingApiDomain": "advertising-api-eu.amazon.com",
    "code": "ae",
    "currencyCode": "AED",
    "domain": "amazon.ae",
    "id": "A2VIGQ35RCS4UG",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "United Arab Emirates",
    "region": "eu",
    "sellerCentralDomain": "sellercentral.amazon.ae",
    "vendorCentralDomain": "vendorcentral.amazon.me",
    "vendorId": "A2KKU8J8O8784X"
  },
  {
    "code": "in",
    "currencyCode": "INR",
    "domain": "amazon.in",
    "id": "A21TJRUUN4KGV",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "India",
    "region": "eu",
    "sellerCentralDomain": "sellercentral.amazon.in",
    "vendorCentralDomain": "vendorcentral.amazon.in"
  },
  {
    "advertisingApiDomain": "advertising-api-fe.amazon.com",
    "code": "au",
    "currencyCode": "AUD",
    "domain": "amazon.com.au",
    "id": "A39IBJ37TRP1C6",
    "imagesDomain": "images-fe.ssl-images-amazon.com",
    "name": "Australia",
    "region": "fe",
    "sellerCentralDomain": "sellercentral.amazon.com.au",
    "vendorCentralDomain": "vendorcentral.amazon.com.au",
    "vendorId": "ANEGB3WVEVKZB"
  },
  {
    "advertisingApiDomain": "advertising-api-fe.amazon.com",
    "code": "jp",
    "currencyCode": "JPY",
    "domain": "amazon.co.jp",
    "id": "A1VC38T7YXB528",
    "imagesDomain": "images-fe.ssl-images-amazon.com",
    "name": "Japan",
    "region": "fe",
    "sellerCentralDomain": "sellercentral.amazon.co.jp",
    "vendorCentralDomain": "vendorcentral.amazon.co.jp",
    "vendorId": "AN1VRQENFRJN5"
  },
  {
    "code": "sg",
    "currencyCode": "SGD",
    "domain": "amazon.sg",
    "id": "A19VAU5U5O7RUS",
    "imagesDomain": "images-fe.ssl-images-amazon.com",
    "name": "Singapore",
    "region": "fe",
    "sellerCentralDomain": "sellercentral.amazon.sg",
    "vendorCentralDomain": "vendorcentral.amazon.com.sg"
  },
  {
    "code": "za",
    "currencyCode": "ZAR",
    "domain": "amazon.co.za",
    "id": "AE08WJ6YKNBMC",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "South Africa",
    "region": "eu",
    "sellerCentralDomain": "sellercentral.amazon.co.za",
    "vendorCentralDomain": "vendorcentral.amazon.co.za",
    "vendorId": "A34KVLZUJN6MA"
  },
  {
    "code": "ie",
    "currencyCode": "EUR",
    "domain": "amazon.ie",
    "id": "A28R8C7NBKEWEA",
    "imagesDomain": "images-eu.ssl-images-amazon.com",
    "name": "Ireland",
    "region": "eu",
    "sellerCentralDomain": "sellercentral-europe.amazon.com",
    "vendorCentralDomain": "vendorcentral.amazon.ie",
    "vendorId": "A2QHQAREJ10JUZ"
  }
]
